<template>
  <div class="main">
    <a-card :loading="tableLoading" style="border-top-right-radius: 20px; border-top-left-radius: 20px"
      :bordered="false">
      <div class="actions">
        <button @click="redirectPreviousUrl" style="
          border: 0;
          background: transparent;
          font-size: 14px;
          text-decoration: none;
          line-height: 30px;
          color: #98c14b;
          display: flex;
        ">
          <p>
            <a-icon type="double-left" />
          </p>
          <p>Go Back</p>
        </button>

        <a-button v-show="transfers.isConfirmed === true" @click="showFulfillment"
          style="background: #418a49; color: #fff">
          Create Fulfillments
        </a-button>
      </div>
      <h3 style="font-size: 28px; line-height: 45px">Transfer Products</h3>
      <div style="display: flex; justify-content: flex-end; margin-bottom: 20px">
        <a-button @click="exportTransferLines" style="
          height: 38px;
          margin-right: 10px;
          border-raduis: 5px;
          background: #418a49;
          color: #fff;
        " icon="export">
          Export
        </a-button>
      </div>
      <div>
        <a-table :columns="transferLinesColumns" :data-source="tableTrasnferLinesData" :loading="tableLoading"
          :pagination="pagination" class="tableStyle">
          <template slot="action" slot-scope="data">
            <a-dropdown>
              <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <a-icon style="font-size: 25px" type="ellipsis" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="showWareDetails(data)">View More?</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table>
      </div>
      <div>
        <WarehouseFulfillmentsTable :transfer="transfers" />
      </div>
      <a-modal :visible="showFulfillmentModal" @cancel="cancelModal" :footer="null" width="800px">
        <a-spin :spinning="loading">
          <h3 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
            Create Fulfillment</h3>
          <create-fulfillment-form :data="data" @inventoryRequest="handleCreateFullment"></create-fulfillment-form>
        </a-spin>
      </a-modal>

    </a-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { NotificationMixins } from "@/mixins/NotificationMixins";
import WarehouseFulfillmentsTable from "@/components/warehouse/tables/WarehouseFulfillments";
import CreateFulfillmentForm from '../backOrders/modal/CreateFulfillmentForm.vue'


import XLSX from "xlsx";

const transferLinesColumns = [
  {
    title: "ID",
    // width: 150,
    key: "id",
    dataIndex: "id",
  },
  {
    title: "Product Name",
    // width: 150,
    key: "productBrandName",
    dataIndex: "productBrandName",
  },
  {
    title: "Category",
    // width: 150,
    key: "categoryName",
    dataIndex: "categoryName",
  },
  {
    title: "Supplier",
    // width: 150,
    key: "supplierName",
    dataIndex: "supplierName",
  },
  {
    title: "Quantity",
    // width: 150,
    key: "quantity",
    dataIndex: "quantity",
  },
  // {
  // title: "Action",
  //     dataIndex: "action",
  //     key: 'action',
  //     scopedSlots: { customRender: "action" },
  // }
];
export default {
  name: "TransferLines",
  mixins: [NotificationMixins],
  components: { WarehouseFulfillmentsTable, CreateFulfillmentForm },
  data() {
    return {
      tableTrasnferLinesData: [],
      fulfillments: {
        requests: [
          {
            id: "",
            productBrandName: "",
            productId: 2,
            key: Date.now(),
            qty: 1,
            quantity: 12,
            disabled: false,
          },
        ],
      },
      data:{},
      tableLoading: false,
      showFulfillmentModal: false,
      expectedDate: null,
      transferLinesColumns,
      pagination: {
        pageSize: 20,
      },
      params: {
        page: -1,
        perPage: -1,
        searchBy: {},
        sortBy: {},
      },
      addSupplierModel: {
        supplierName: "",
        supplierAddress: "",
        supplierPhoneNumber: "",
        supplierDescription: "",
      },
      transfers: {},
      wareHouseId: "",
      addSupplierVisible: false,
      dateFormat: "DD/MM/YYYY",
      startDate: moment(),
      endDate: moment(),
      loading: false,
      rules: {
        notes: [
          {
            required: true,
            message: "Please this field cannot be empty",
            trigger: "change",
          },
        ],
        name: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],

        manufacturerName: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],
        description: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        manufacturerDescription: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        supplierName: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],
        supplierAddress: [
          {
            required: true,
            message: "Please enter address",
            trigger: "change",
          },
        ],
        supplierPhoneNumber: [
          {
            required: true,
            message: "Please enter phone number",
            trigger: "change",
          },
        ],
        supplierDescription: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        categoryName: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],
        categoryDescription: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        categoryGroup: [
          {
            required: true,
            message: "Please select your option",
            trigger: "change",
          },
        ],
        isRestricted: [
          {
            required: true,
            message: "Please select your option",
            trigger: "change",
          },
        ],
        categoryCommission: [
          {
            required: true,
            message: "Please enter commission",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getWareHouseTransferLinesInfo", "getWareHouseInfo"]),
  },
  methods: {
    ...mapActions([
      "getAllWarehousesData",
      "setWareHouseInfo",
      "updateProductSupplier",
    ]),
    onChange(date, dateString) {
      // console.log(date, dateString);
      this.startDate = dateString[0];
      this.endDate = dateString[1];
      // console.log("startDate | ", this.startDate);
      // console.log("endDate | ", this.endDate);
    },
    moment,
    cancelModal() {
      this.showFulfillmentModal = false;
    },
    showFulfillment(){
      console.log("tableTrasnferLinesData | ", this.tableTrasnferLinesData)
       this.data = {
        id: this.transfers.id,
        data: this.tableTrasnferLinesData.map(product => ({
          productId: product.action.productId,
          productName: product.productBrandName,
          quantity: product.quantity,
        }))
      }
      
      this.showFulfillmentModal = true;
    },
    async handleCreateFullment(data){
      this.loading = true
       const response = await this.$store.dispatch("fulfillments/CreateFulfillments", data);
       this.loading = false
       if(response.status == 200){
          this.showFulfillmentModal = false;
          this.showSuccessAlert("Fulfillment Created Successfully")
          this.getAllTransferLines()
       }else{
         this.showErrorAlert(response.data.messages)
       }
    },
    handleQuantityChange(fulfillment) {
      // console.log(fulfillment);
      if (fulfillment.qty > fulfillment.quantity) {
        this.showErrorAlert(
          `Sorry you have exceeded the maximum quantity of kindly choose between 1 to ${fulfillment.quantity}`
        );
      }
    },
    dateChangeHandler(dateString) {
      this.expectedDate = moment(dateString);
    },
    removeFulfillment(item) {
      let index = this.fulfillments.requests.indexOf(item);
      if (index !== -1) {
        // this.fulfillments.requests.splice(index, 1);
        // console.log(item);
        item.disabled = true;
      }
    },
    addFulfillment(fulfillment) {
      fulfillment.disabled = false;
    },
    async handleCreateFulfillments() {
      let errors = 0;
      this.fulfillments.requests.forEach((fulfillment) => {
        if (fulfillment.qty > fulfillment.quantity) {
          this.showErrorAlert(
            `${fulfillment.productBrandName}: Sorry you have exceeded the maximum quantity of kindly choose between 1 to ${fulfillment.quantity}`
          );
          errors += 1;
        }
      });
      if (errors) {
        this.showErrorAlert(
          `Error: please make sure you haven't exceeded any maximum quantity.`
        );
      }
      let productAndQuantity = {};
      this.fulfillments.requests.forEach((fulfillment) => {
        if (!fulfillment.disabled) {
          productAndQuantity[fulfillment.productId] = Number(fulfillment.qty);
        }
      });
      let payload = {
        inventoryRequestId: this.transfers.id,
        data: {
          expectedAt: this.expectedDate,
          productAndQuantity,
        },
      };
      // console.log("payload | ", payload)
      // debugger;
      const res = await this.$store.dispatch(
        "fulfillments/CreateFulfillments",
        payload
      );
      res.status === 200
        ? this.showSuccessAlert("Successfully created fulfillment.")
        : this.showErrorAlert(`${res.data.messages[0]}`);

      this.showFulfillmentModal = false
      location.reload(); // TODO: later remove this line to refetch transfer lines
    },
    showSupplierModal() {
      this.addSupplierVisible = true;
    },
    supplierOnChange(checked) {
      this.isSupplierEnabled = checked;
    },
    showWareDetails() {
      // this.setWareHouseInfo(data)
      // this.$router.push({
      // name: 'warehouse-details',
      // params: { id: data.id }
      // }).catch(()=>{})
    },

    exportTransferLines() {
      const dataToExport = [["Transfer ID", "Product Name", "Quantity"]];

      this.transfers.requestLines.forEach((v) => {
        dataToExport.push([v.id, v.productBrandName, v.quantity]);
      });

      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Warehouse-Transfer-Products-Report-${moment().format(
          "DD-MM-YYYY"
        )}.xlsx`
      );
      this.exportLoading = false;
      this.showSuccessAlert("Data Successfully Exported");
    },

    redirectPreviousUrl() {
      this.$router.back();
    },

    handleAddSupplierCancel() {
      this.addSupplierVisible = false;
    },
    handleAddSupplierSubmit() {
      this.$refs.addSupplierForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const request = {
            name: this.addSupplierModel.supplierName,
            address: this.addSupplierModel.supplierAddress,
            metadata: {
              phoneNumber: this.addSupplierModel.supplierPhoneNumber,
              description: this.addSupplierModel.supplierDescription,
            },
            status: 1,
          };

          this.addProductSupplier(request).then(
            (response) => {
              this.loading = false;
              if (response.status === 200) {
                this.getProductsMgtData();
                this.showSuccessAlert("Supplier Added Successfully");
                this.addSupplierVisible = false;
                this.$refs.addSupplierForm.resetFields();
              } else {
                this.this.showErrorAlert(response.data.messages);
              }
            },
            (error) => {
              this.loading = false;
              this.this.showErrorAlert(JSON.stringify(error));
            }
          );
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },

    async getAllTransferLines() {
      this.tableTrasnferLinesData = this.transfers.requestLines.map(
        (transferLines) => ({
          key: transferLines.id,
          id: transferLines.id,
          productBrandName: transferLines.productBrandName,
          categoryName: transferLines.categoryName ? transferLines.categoryName : "N/A",
          supplierName: transferLines.supplierName ? transferLines.supplierName :"N/A",
          quantity: transferLines.quantity,
          action: transferLines,
        })
      );
    },
  },
  watch: {
    tableTrasnferLinesData: function (newData) {
      if (newData.length) {
        let newArr = new Array(...newData);
        const newFulfillment = newArr.map((arr) => ({
          id: arr.id,
          productBrandName: arr.productBrandName,
          categoryName: arr.categoryName,
          supplierName: arr.supplierName,
          productId: arr.action.productId,
          key: arr.id + Date.now(),
          qty: arr.quantity,
          quantity: arr.quantity,
          disabled: false,
        }));
        this.fulfillments.requests = newFulfillment;
        // console.log("fulfillments->", this.fulfillments);
      }
    },
  },
  created() {
    if (this.getWareHouseTransferLinesInfo) {
      this.transfers = this.getWareHouseTransferLinesInfo;
      this.getAllTransferLines();
    }
    if (this.getWareHouseInfo) {
      this.wareHouseId = this.getWareHouseInfo.id;
    }
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
}
.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}
.tableStyle >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
  color: #fff;
}
.tableStyle >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}
a {
  color: #418a49;
}
a:hover {
  color: #418a49;
}
button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}
.disabledIcon {
  opacity: 0.5;
  cursor: not-allowed;
}
button {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}
.tableStyle >>> .ant-spin-dot-item {
  background-color: #418a49;
}

.ant-switch-checked {
  background-color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>